/**
 * Strip Vue reactive proxies / non-cloneable refs before persisting to IDB.
 * idb-keyval uses structured clone which can choke on certain Proxy shapes,
 * silently rejecting the write. JSON round-trip guarantees plain data.
 *
 * Used by both the version-tracked cache (`idbCache`) and the runtime
 * mirror buckets (`offlineBuckets`).
 */
export function plainify<T>(data: T): T {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch {
    return data;
  }
}
